import React, { useEffect, useState } from 'react';

import './ConversationModalFollowUp.css';
import '../ConversationDetailsModal.css';
import Field from '/src/components/UI/Field/Field';

import ConversationService from '../../../services/ConversationService';
import { formatDateWithoutSeconds } from '/src/utils/dateWithoutSeconds';
import IconButton from '/src/components/UI/Button/IconButton/IconButton';
import ConversationMarker from '../../ConversationMarker/ConversationMarker';
import useMarkers from "../../../hooks/useMarkers"
import IconsConversation from '../../../data/types/IconsConversation';
import Icons from '/src/features/phone/data/types/Icons';

const ConversationModalFollowUp = ({ data, state }) => {
    const [conversation, setConversation] = useState(data);
    const [listMarkerAdded, setListMarkerAdded] = useState(conversation.markers)
    const { addMarkersToConversation, deleteMarkerFromConversation } = ConversationService;
    const { markers, setMarkers } = useMarkers(data.id);
    const [printAddSection, setPrintAddSection] = useState(false);
    const [listMarkerToAdd, setListMarkerToAdd] = useState([])

    const dataCommons = [
        { name: "ID", value:  state == 3 ? data.bot_job_id : data.id },
        { name: "Date", value: formatDateWithoutSeconds(state == 3 ? data.schedule : data.created_at, state == 3)},
        { name: "Bot", value: state == 3 ? data.bot.name : data.name },
    ]

    const onClickAddMarker = async (marker) => {
        let dataToSend = { markers: marker.id.toString() };
        const [response, errors] = await addMarkersToConversation(dataToSend, conversation.id);
        if (errors != null) {
            console.log(errors)
            return;
        }
        let updatedMarkers = [...listMarkerAdded, marker]
        let _conversation = { ...conversation, markers: updatedMarkers };

        setListMarkerAdded(updatedMarkers);
        updateListMarkersAvailable(_conversation);
        setConversation(_conversation);
    };

    const onClickDeleteMarker = async (marker) => {
        const [response, errors] = await deleteMarkerFromConversation(marker.id, conversation.id);
        if (errors != null) {
            console.log(errors)
            return;
        }
        let updatedMarkers = conversation.markers.filter(_marker => _marker.id !== marker.id);
        let _conversation = { ...conversation, markers: updatedMarkers };
        setConversation(_conversation);
        updateListMarkersAvailable(_conversation);
        setListMarkerAdded(current => current.filter(_m => { return _m.id !== marker.id }))

    };


    const updateListMarkersAvailable = (_conversation) => {
        let listMarkerIdUsed = _conversation.markers.map(marker => marker.id);
        let listMarkersAvailable = markers.filter(marker => !listMarkerIdUsed.includes(marker.id))
        setListMarkerToAdd(listMarkersAvailable);
    }

    useEffect(() => {
        if (markers == null || conversation.markers == null) return
        updateListMarkersAvailable(conversation);
    }, [markers])
    return (
        <div className='conversation_modal_content_detail'>
            {state == 1 || state == 2 ?
                <div className='text-size'>
                    <div>
                        <Field label="Markers" listLabelClassName="titles-input"></Field>
                        <div className='marker-container'>
                            {listMarkerAdded.map(marker => (
                                <ConversationMarker marker={marker} mode={1} icon={state == 2 ? "" : "fas fa-trash"} onClick={() => onClickDeleteMarker(marker)} />
                            ))}
                        </div>

                        {
                            state != 2 &&
                            <>
                                <div className='conversation_follow_up_separator' ></div>
                                <div style={{ display: "flex", alignItems: "center" }}>
                                    <Field label="Add a new Marker" listLabelClassName="titles-input"></Field>
                                    <IconButton className="main-iconButton add-hover modalButtons-input" icon={(!printAddSection ? "fas fa-plus-circle" : "fas fa-minus-circle") + " content_detail_icon_add_marker"} onClick={() => setPrintAddSection(!printAddSection)} />
                                </div>

                            </>
                        }

                        {
                            printAddSection && state != 2 &&
                            <>
                                {markers != null && listMarkerToAdd.length > 0 ?
                                    listMarkerToAdd.map(marker => (
                                        <ConversationMarker marker={marker} mode={1} icon={state == 2 ? "" : "fas fa-plus-circle"} onClick={() => onClickAddMarker(marker)} />
                                    ))
                                    : <div className='conversation_follow_up_no_marker_message'>There are no more markers available</div>
                                }
                            </>
                        }
                    </div>
                </div>
                :
                <div className='conversation_information_details_block_relaunch'>
                    <div className='container_element_block_relaunch'>

                        <Field label="Channel" listLabelClassName="titles-input text-bold"></Field>
                        <div className="channel-icon-container">
                            <img width="30px" style={{ marginLeft: (data.channel_type_id == 1 || data.bot_job_type?.name == "web") ? "-5px" : "0", marginTop: "7px" }} srcSet={data.channel_type_id ? Icons[data.channel_type.name] : IconsConversation[data.bot_job_type.name]}></img>
                        </div>
                    </div>
                    {
                        dataCommons.map((row) =>
                            <div className='container_element_block_relaunch'>
                                <Field label={row.name} listLabelClassName="titles-input"></Field>
                                <Field label={row.value} listLabelClassName="titles-input conversation_detail_text_input_value_weight"></Field>
                            </div>
                        )
                    }
                </div>
            }


        </div>
    );
};

export default ConversationModalFollowUp;